import React from 'react';
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Box,
  FormHelperText,
  Paper,
  FormControl,
  useTheme,
  alpha,
} from '@mui/material';
import { LessonQuestionOptionI } from 'types';
import { UseFormRegister, Controller, Control } from 'react-hook-form';
import { colors } from 'Constants/Colors';

interface Props {
  options: LessonQuestionOptionI[];
  register: UseFormRegister<any>;
  control: Control<any>;
  name: string;
  error?: any;
  currentValue?: string;
}

const QuestionnaireOptions = ({ options, control, name, error, currentValue }: Props) => {
  const theme = useTheme();

  return (
    <Box>
      <FormControl component="fieldset" sx={{ width: '100%' }}>
        <Controller
          name={name}
          control={control}
          defaultValue={currentValue || ''}
          render={({ field }) => (
            <RadioGroup {...field}>
              {options.map(option => (
                <Paper
                  key={option.id}
                  elevation={0}
                  sx={{
                    mb: 1.5,
                    p: 0.5,
                    borderRadius: 2,
                    border: `1px solid ${theme.palette.divider}`,
                    transition: 'all 0.2s',
                    '&:hover': {
                      bgcolor: alpha(colors.GREEN, 0.05),
                      borderColor: colors.GREEN,
                    },
                    ...(field.value === option.id && {
                      bgcolor: alpha(colors.GREEN, 0.1),
                      borderColor: colors.GREEN,
                    }),
                  }}
                >
                  <FormControlLabel
                    value={option.id}
                    control={
                      <Radio
                        sx={{
                          '& .MuiSvgIcon-root': {
                            fontSize: 20,
                          },
                          color: colors.GREEN,
                          '&.Mui-checked': {
                            color: colors.GREEN,
                          },
                        }}
                      />
                    }
                    label={
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: field.value === option.id ? 500 : 400,
                          color: field.value === option.id ? colors.GREEN : theme.palette.text.primary,
                        }}
                      >
                        {option.response}
                      </Typography>
                    }
                    sx={{
                      width: '100%',
                      m: 0,
                      py: 0.5,
                    }}
                  />
                </Paper>
              ))}
            </RadioGroup>
          )}
        />
        {error && (
          <FormHelperText error sx={{ ml: 2 }}>
            {error.message}
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

export default QuestionnaireOptions;
